import { ChipColor } from 'src/shared/design-system/Chip';
import { ThumbsDownV2, ThumbsUpV2 } from 'src/shared/design-system/Icon';
import { match } from 'ts-pattern';
import { ConsumerOrderShefChip } from './ConsumerOrderShefChip';

const ICON_SIZE = 10;

export const RatingChip = ({ ratingPercent }: { ratingPercent: 100 | 0 }): JSX.Element => {
  const { icon, color } = match(ratingPercent)
    .with(100, () => ({ icon: <ThumbsUpV2 width={ICON_SIZE} height={ICON_SIZE} />, color: ChipColor.LIGHT_YELLOW }))
    .with(0, () => ({ icon: <ThumbsDownV2 width={ICON_SIZE} height={ICON_SIZE} />, color: ChipColor.LIGHT_RED }))
    .exhaustive();

  return <ConsumerOrderShefChip text='' color={color} icon={icon} />;
};
